module.exports = __webpack_public_path__ + "static/media/next-cargo-logo.df6d2472.svg";